import DashboardLayout from '@/layouts/DashboardLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';
import { DonationsRouteName } from '@/types/router/name/donations';
import { DonationsRoutePath } from '@/types/router/path/donations';

export default [
    {
        path: DonationsRoutePath.Donations,
        name: DonationsRouteName.Donations,
        component: () => import('@/pages/donations/index.vue'),
        meta: {
            group: 'donations',
            title: 'Donations',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsOrganization,
        name: DonationsRouteName.DonationsOrganization,
        component: () => import('@/pages/donations/type/organization/index.vue'),
        meta: {
            group: 'donations',
            title: 'Daftar Donatur Organisasi',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsOrganizationCreate,
        name: DonationsRouteName.DonationsOrganizationCreate,
        component: () => import('@/pages/donations/type/organization/create/index.vue'),
        meta: {
            group: 'donations',
            title: 'Tambah Organisasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsOrganizationUpdate,
        name: DonationsRouteName.DonationsOrganizationUpdate,
        component: () => import('@/pages/donations/type/organization/update/index.vue'),
        meta: {
            group: 'donations',
            title: 'Update Organisasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsOrganizationDetail,
        name: DonationsRouteName.DonationsOrganizationDetail,
        component: () => import('@/pages/donations/type/organization/detail/index.vue'),
        meta: {
            group: 'donations',
            title: 'Detail Donasi Organisasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsIncomeCreate,
        name: DonationsRouteName.DonationsIncomeCreate,
        component: () => import('@/pages/donations/status/income/create/index.vue'),
        meta: {
            group: 'donations',
            title: 'Tambah Pemasukan Donasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsIncomeUpdate,
        name: DonationsRouteName.DonationsIncomeUpdate,
        component: () => import('@/pages/donations/status/income/update/index.vue'),
        meta: {
            group: 'donations',
            title: 'Update Pemasukan Donasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsOrganizationCreateDonationIncome,
        name: DonationsRouteName.DonationsOrganizationCreateDonationIncome,
        component: () => import('@/pages/donations/status/income/create/index.vue'),
        meta: {
            group: 'donations',
            title: 'Tambah Pemasukan Donasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsOrganizationUpdateDonationIncome,
        name: DonationsRouteName.DonationsOrganizationUpdateDonationIncome,
        component: () => import('@/pages/donations/status/income/update/index.vue'),
        meta: {
            group: 'donations',
            title: 'Update Pemasukan Donasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsExpenseCreate,
        name: DonationsRouteName.DonationsExpenseCreate,
        component: () => import('@/pages/donations/status/expense/create/index.vue'),
        meta: {
            group: 'donations',
            title: 'Tambah Pengeluaran Donasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsExpenseUpdate,
        name: DonationsRouteName.DonationsExpenseUpdate,
        component: () => import('@/pages/donations/status/expense/update/index.vue'),
        meta: {
            group: 'donations',
            title: 'Update Pengeluaran Donasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsOrganizationCreateDonationExpense,
        name: DonationsRouteName.DonationsOrganizationCreateDonationExpense,
        component: () => import('@/pages/donations/status/expense/create/index.vue'),
        meta: {
            group: 'donations',
            title: 'Tambah Pengeluaran Donasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsOrganizationUpdateDonationExpense,
        name: DonationsRouteName.DonationsOrganizationUpdateDonationExpense,
        component: () => import('@/pages/donations/status/expense/update/index.vue'),
        meta: {
            group: 'donations',
            title: 'Update Pengeluaran Donasi',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: DonationsRoutePath.DonationsIndividual,
        name: DonationsRouteName.DonationsIndividual,
        component: () => import('@/pages/donations/type/individual/index.vue'),
        meta: {
            group: 'donations',
            title: 'Daftar Donatur Individu',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
